import _ from 'lodash'
import { mapGetters } from 'vuex'
import color from '@/util/color-generator.js'

const moment = require('moment')
const momentTz = require('moment-timezone')

export const mixin = {
  data() {
    return {
      defaultStartDate: new Date('2017-01-01'),
      defaultEndDate: new Date()
    }
  },
  methods: {
    dateValidate(date) {
      if (date < this.defaultStartDate || date > this.defaultEndDate) {
        return false
      }
      return true
    },
    simpleString(string) {
      // return string.replace(/ /g, '').replace(/[^0-9][&\/\\#,+()$~%.'":*-?<>{}]/g, '')
      return string.replace(/ /g, '').replace(/[^a-zA-Z0-9 ]/g, '')
    }
  },
  computed: {
    isMobileView() {
      return this.$vuetify.breakpoint.name === 'sm' || this.$vuetify.breakpoint.name === 'xs'
    }
  },
  filters: {
    // Round the value to n decimal places where n is an input parameter
    round(value, n = 2) {
      if (value === 'N/A' || value === null || value === undefined) {
        return 'N/A'
      }
      return Number.parseFloat(value).toFixed(n)
    },
    numberWithCommas: (x) => {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    value(x) {
      if (x === null || x === undefined || x === "N/A") return 0;

      const data = Number(x)
      const absX = Math.abs(x);

      if (absX >= 100000000) {
        return (data / 1000000).toFixed(3);
      }
      
      if (absX >= 1000000) {
        return (data / 1000).toFixed(3);
      }

      return Number(data.toFixed(0));
    },
    unit(x, component) {
      if (x === null || x === undefined) return "";

      const absX = Math.abs(x);

      const unitMap = {
        dc: ["kWp", "MWp", "GWp"],
        ac: ["kW", "MW", "GW"],
        totalGen: ["kWh", "MWh", "GWh"]
      };

      if (component === "availPercent") {
        if (x === 100.0) return "100";
        if (x === 0.0) return "0";
        return x;
      }

      const units = unitMap[component];
      if (!units) return "";

      if (absX >= 100000000) return units[2];
      if (absX >= 1000000) return units[1];

      return units[0];
    },
    truncateText: (text) => {
      let length = window.innerHeight < 600 ? 7 : 15
      if (text.length > length) {
        return text.substring(0, length) + '...'
      }
      return text
    },
    truncateText10: (text) => {
      let length = 10
      if (text.length > length) {
        return text.substring(0, length) + '...'
      }
      return text
    }
  }
}

export const mapGettersMixin = {
  data() {
    return {
      cacheInterval: null
    }
  },
  beforeDestroy() {
    if (this.cacheInterval) {
      clearInterval(this.cacheInterval)
    }
  },
  computed: {
    ...mapGetters(['getGeneralState']),
    isDark() {
      return this.getGeneralState('theme_dark')
    },
    theme() {
      return this.isDark ? 'dark' : 'light'
    },
    isReload() {
      return this.getGeneralState('autoReload') && (this.getGeneralState('autoReload') || this.getGeneralState('instantRefresh'))
    },
    reloadTime() {
      return this.getGeneralState('reloadTimer')
    }
  },
  methods: {
    setIntervalWithoutDelay(func, interval = this.reloadTime) {
      if (this.cacheInterval) {
        clearInterval(this.cacheInterval)
      }
      func()
      this.cacheInterval = setInterval(func, interval)
      return this.cacheInterval
    }
  }
}

export const colorMixin = {
  data() {
    return {
      dataLength: 0
    }
  },
  computed: {
    colors() {
      return color.generateColor(this.dataLength)
    }
  }
}

export const miscellaneous = {
  methods: {
    isObject(param) {
      return param != null && typeof param === 'object'
    },
    // TODO: Move this to Mixin (COMPARE OBJECT)
    isObjectEqual(object1, object2) {
      const keys1 = Object.keys(object1)
      const keys2 = Object.keys(object2)
      if (keys1.length !== keys2.length) {
        return false
      }
      for (const key of keys1) {
        const val1 = object1[key]
        const val2 = object2[key]
        const areObjects = this.isObject(val1) && this.isObject(val2)
        if (
          (areObjects && !this.isObjectEqual(val1, val2)) ||
          (!areObjects && val1 !== val2)
        ) {
          return false
        }
      }
      return true
    },
    arrDifference(arr1, arr2) {
      return _.difference(arr1, arr2)
    },
    isArrEqual(a, b) {
      return a.length === b.length &&
        a.every((v, i) => {
          if (Array.isArray(v)) {
            return this.isArrEqual(v, b[i])
          } else if (typeof v === 'string') {
            return v === b[i]
          } else if (typeof v === 'object') {
            return this.isObjectEqual(v, b[i])
          }
        })
    },
   arraySortHandler(dataArray, param, order, ignoreRowKey, slotWise) {
      function naturalSortKey(value) {
        return value.split('-').map(part => {
          const num = Number(part);
          return isNaN(num) ? part : num;
        });
      }

      function compareHierarchical(a, b, order = 'asc') {
        const aParts = naturalSortKey(a);
        const bParts = naturalSortKey(b);

        for (let i = 0; i < Math.max(aParts.length, bParts.length); i++) {
          const aPart = aParts[i];
          const bPart = bParts[i];

          if (aPart === undefined) return order === 'asc' ? -1 : 1;
          if (bPart === undefined) return order === 'asc' ? 1 : -1;

          if (typeof aPart === 'number' && typeof bPart === 'number') {
            if (aPart !== bPart)
              return order === 'asc' ? aPart - bPart : bPart - aPart;
          } else if (aPart !== bPart) {
            return order === 'asc'
              ? aPart.localeCompare(bPart)
              : bPart.localeCompare(aPart);
          }
        }
        return 0;
      }

      return dataArray.sort((a, b) => {
        const clonedA = _.cloneDeep(a)
        const clonedB = _.cloneDeep(b)

        if (clonedA[ignoreRowKey] == 'Total' || clonedB[ignoreRowKey] == 'Total') {
          return 0
        }

        if (slotWise && param == 'date_frame') {
          const timeA = clonedA['date_frame'].split(' - ')[0]
          const timeB = clonedB['date_frame'].split(' - ')[0]
          const momentA = moment(timeA, "YYYY-MM-DD HH:mm");
          const momentB = moment(timeB, "YYYY-MM-DD HH:mm");
          if (order === 'asc' || order == undefined) {
            return momentA.isBefore(momentB) ? -1 : 1;
          } else {
            return momentA.isAfter(momentB) ? -1 : 1;
          }
        } else {
          const valueA = clonedA[param]
          const valueB = clonedB[param]

          // **Use your hierarchical comparison for hyphenated strings**
          if (typeof valueA === 'string' && typeof valueB === 'string' &&
            valueA.includes('-') && valueB.includes('-')) {
            return compareHierarchical(valueA, valueB, order);
          }

          // Original logic for other cases
          if (isNaN(+clonedA[param]) && typeof clonedA[param] !== 'undefined') {
            if (/-[0-9]+/g.test(clonedB[param])) {
              if (/-[0-9]+/g.test(clonedA[param])) {
                if (clonedA[param].replace(/[0-9.]/g, '') !== clonedB[param].replace(/[0-9.]/g, '')) {
                  return order === 'asc' ? -1 : 1
                } else {
                  if (order === 'asc') {
                    return +(clonedA[param].replace(/[^0-9.]/g, '')) - +(clonedB[param].replace(/[^0-9.]/g, ''))
                  } else {
                    return +(clonedB[param].replace(/[^0-9.]/g, '')) - +(clonedA[param].replace(/[^0-9.]/g, ''))
                  }
                }
              } else {
                return order === 'asc' ? -1 : 1
              }
            } else if (/-[0-9]+/g.test(clonedA[param])) {
              return order === 'asc' ? 1 : -1
            } else {
              return 0
            }
          } else {
            if (typeof clonedA[param] === 'undefined' || clonedA[param] === null || clonedA[param] === 'N/A' || clonedA[param] === 'No Data') {
              clonedA[param] = 0
            }
            if (typeof clonedB[param] === 'undefined' || clonedB[param] === null || clonedB[param] === 'N/A' || clonedB[param] === 'No Data') {
              clonedB[param] = 0
            }
            if (clonedA[param] < clonedB[param]) {
              return order === 'asc' ? -1 : 1
            } else if (clonedA[param] > clonedB[param]) {
              return order === 'asc' ? 1 : -1
            } else {
              return 0
            }
          }
        }
      })
    }
  }
}

export const timezoneMixin = {
  data() {
    return {
      time: momentTz().format('YYYY-MM-DD HH:mm z')
    }
  },
  computed: {
    ...mapGetters(['getActivePlantTimezone'])
  },
  methods: {
    updateTime() {
      this.time = this.timezoneTime()
    },
    timezoneTime(t) {
      return momentTz(t).tz(this.getActivePlantTimezone).format('YYYY-MM-DD HH:mm z')
    }
  }
}

export const unitConvertorMixin = {
  methods: {
    convert(value, unit, finalUnit) {
      const table = ['w', 'k', 'm', 'g', 't']

      if (value >= 1000) {
        const currentUnit = (unit.split('')[0]).toLowerCase()
        const currentIndex = table.indexOf(currentUnit)
        const requiredUnit = (finalUnit.split('')[0]).toLowerCase()
        const requiredIndex = table.indexOf(requiredUnit)
        const unitDifference = requiredIndex - currentIndex
        return `${(value / Math.pow(1000, unitDifference)).toFixed(2)} ${finalUnit}`
      } else {
        return `${value.toFixed(2)} ${unit}`
      }
    },
    minuteTOHours(value, unit, finalUnit) {
      const table = ['s', 'm', 'h']
      if (value >= 60) {
        const currentUnit = (unit.split('')[0]).toLowerCase()
        const currentIndex = table.indexOf(currentUnit)
        const requiredUnit = (finalUnit.split('')[0]).toLowerCase()
        const requiredIndex = table.indexOf(requiredUnit)
        const unitDifference = requiredIndex - currentIndex
        const hours = Math.floor((value / Math.pow(60, unitDifference)))
        return `${hours} ${finalUnit} ${hours * Math.pow(60, unitDifference) === value ? '' : value - (hours * Math.pow(60, unitDifference))} ${unit}`
      } else {
        return `${value} ${unit}`
      }
    }
  }
}

export const getClientSideInfo = {
  data() {
    return {
      isLocationEnabled: false,
      locationData: {},
      locationDisplayMsg: "",
    };
  },
  computed: {
    isRanOnLocal() {
      return process.env.VUE_APP_RUN_TIME && process.env.VUE_APP_RUN_TIME === 'local'
    }
  },
  mounted() {
    if (!this.isRanOnLocal) {
      this.requestGeolocation();
    }
  },
  methods: {
    async clientsInfo() {
      const { width, height, colorDepth, pixelDepth, availWidth, availHeight } =
        screen;
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      return {
        screenInfo: {
          width,
          height,
          colorDepth,
          pixelDepth,
          availWidth,
          availHeight,
        },
        clientLanguage: navigator.language || navigator.userLanguage,
        clientTimezone: timeZone,
        location: this.locationData,
      };
    },
    requestGeolocation() {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const {
              latitude,
              longitude,
              accuracy,
              altitude,
              altitudeAccuracy,
            } = position.coords;
            this.locationData = {
              latitude,
              longitude,
              accuracy,
              altitude,
              altitudeAccuracy,
            };
            this.isLocationEnabled = true;
          },
          async (error) => {
            this.isLocationEnabled = false;
            switch (error.code) {
              case error.PERMISSION_DENIED:
                this.locationDisplayMsg =
                  "Please allow access to your location, to log in.";
                console.log("User denied the request for Geolocation.");
                break;
              case error.POSITION_UNAVAILABLE:
                this.locationDisplayMsg =
                  "Please use a different device with GPS to log in.";
                console.log("Location information is unavailable.");
                break;
              case error.TIMEOUT:
                this.locationDisplayMsg =
                  "Please allow access to your location, to log in.";
                console.log(
                  "The request to get the user's location timed out."
                );
                break;
              case error.UNKNOWN_ERROR:
                this.locationDisplayMsg =
                  "Please try with a different device / browser to log in.";
                console.log("An unknown error occurred.");
                break;
            }
          }
        );
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    }
  }
}

export const setTheme = {
  methods: {
    setDark() {
      this.$vuetify.theme.bg = "#04112F";
      this.$vuetify.theme.primary = "#000427";
      this.$vuetify.theme.secondary = "#3D485D";
      this.$vuetify.theme.primaryText = "#ffffff";
      this.$vuetify.theme.sixth = "#121a37";
      this.$vuetify.theme.extraGrey = "#D4D4D4";
      this.$vuetify.theme.number = "#668cf6";
    },
    setLight() {
      this.$vuetify.theme.primary = "#fdfaf6";
      this.$vuetify.theme.bg = "#e4efe7";
      this.$vuetify.theme.secondary = "#faf1e6";
      this.$vuetify.theme.primaryText = "#000000";
      this.$vuetify.theme.sixth = "#D9D9D9";
      this.$vuetify.theme.extraGrey = "#696969";
      this.$vuetify.theme.number = "#2C62F7";
    }
  }
}